import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid, Header, Icon, Table } from 'semantic-ui-react';
import { ProcedureDto } from 'ts-types/api.types';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
    cursor: pointer;
`;

const StyledBtnContainer = styled.div`
  margin-bottom: 5px;
  white-space: nowrap !important;
`;

const StyledButtons = styled(Grid.Column)`
  padding: 0 !important;
  margin: 0 0 0 4px !important;
  flex: 1 1 auto;
`;

const StyledTableRight = styled(Grid.Column)`
    padding-right: 1rem !important;
    padding-left: 0 !important;
    flex: 50 50 auto;
`;

const StyledTableLeft = styled(Grid.Column)`
    padding-left: 1rem !important;
    padding-right: 0 !important;
    flex: 50 50 auto;
`;

const StyledTableRow = styled(Table.Row)`
  cursor: pointer;
`;

const ScrollableTableWrapper = styled.div`
  height: 375px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34,36,38,.15);
  box-shadow: none;
  border-radius: .28571429rem;
  flex: 50 50 auto;

  & .ui.table {
    border: none;
  }

   & .ui.table thead tr:first-child > th {
      position: sticky !important;
      top: 0;
      z-index: 2;
      background: #fff;
  }

  & .ui.table tbody tr:last-child > td {
      border-bottom: 1px solid rgba(34,36,38,.15)
  }
`;

interface Props extends MessageSourceProps {
  procedures?: Array<ProcedureDto>,
  selectedProcedures?: Array<number>,
  availableProcedures?: Array<number>,
  setSelectedProcedures: (selectedProcedures: Array<number>) => void
}

interface State {
  selectedAddProcedures?: Array<number>,
  availableProcedures?: Array<number>,
  markedProcedures: Array<number>
}

class ProcedureGroupSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {selectedProcedures = [], availableProcedures = []} = this.props;

    this.state = {
      selectedAddProcedures: selectedProcedures,
      availableProcedures: availableProcedures,
      markedProcedures: []
    };
  }

  procedureSelection = (procedureId: number) => {

    const {markedProcedures, availableProcedures = [], selectedAddProcedures = []} = this.state;

    if (markedProcedures.length === 0) {
      this.setState({
        markedProcedures: [procedureId]
      })
    } else if (markedProcedures.includes(procedureId)) {
      const filter = markedProcedures.filter(proc => proc !== procedureId);

      this.setState({
        markedProcedures: [...filter]
      })
    } else if (availableProcedures.includes(procedureId)) {
      const filter = markedProcedures.filter(proc => selectedAddProcedures.includes(proc));

      if (filter.length > 0) {
        this.setState({
          markedProcedures: [procedureId]
        })
      } else {
        this.setState({
          markedProcedures: [...markedProcedures, procedureId]
        })
      }
    } else {
      const filter = markedProcedures.filter(proc => availableProcedures.includes(proc));

      if (filter.length > 0) {
        this.setState({
          markedProcedures: [procedureId]
        })
      } else {
        this.setState({
          markedProcedures: [...markedProcedures, procedureId]
        })
      }
    }
  };

  addRemoveProcedure = () => {

    const {setSelectedProcedures} = this.props;
    const {markedProcedures = [], selectedAddProcedures = [], availableProcedures = []} = this.state;

    if (markedProcedures.length > 0) {
      if (selectedAddProcedures.some(proc => markedProcedures.includes(proc))) {

        const filteredSelectedProcedures = selectedAddProcedures.filter(proc => !markedProcedures.includes(proc));

        this.setState({
          availableProcedures: [
            ...availableProcedures,
            ...markedProcedures
          ],
          selectedAddProcedures: filteredSelectedProcedures,
          markedProcedures: []
        });

        setSelectedProcedures(filteredSelectedProcedures);
      } else {

        const filteredProcedures = availableProcedures.filter(proc => !markedProcedures.includes(proc));
        const selectedProcedures = [
          ...selectedAddProcedures,
          ...markedProcedures
        ];

        this.setState({
          selectedAddProcedures: selectedProcedures,
          availableProcedures: filteredProcedures,
          markedProcedures: []
        });

        setSelectedProcedures(selectedProcedures);
      }
    }
  };

  markUnmarkAllProcedures = (markProcedures: Array<number>) => {
    this.setState({
      markedProcedures: [...markProcedures]
    })
  };

  render(): React.ReactNode {

    const {selectedAddProcedures = [], availableProcedures = [], markedProcedures = []} = this.state;
    const {procedures = [], getMessage} = this.props;

    const selectableProcedures: Array<JSX.Element> = [];
    const usedProcedures: Array<JSX.Element> = [];

    procedures.forEach(proc => {

      const active = markedProcedures.includes(proc.id);

      if (proc.id && availableProcedures.includes(proc.id)) {

        const availableProcedureDescription = (
            <StyledTableRow key={proc.id}
                            onClick={() => this.procedureSelection(proc.id)}
                            active={active}
            >
              <Table.Cell>{proc.code}</Table.Cell>
              <Table.Cell>{proc.description}</Table.Cell>
            </StyledTableRow>
        );

        selectableProcedures.push(availableProcedureDescription)
      }

      if (proc.id && selectedAddProcedures.includes(proc.id)) {

        const usedProcedureDescription = (
            <StyledTableRow key={proc.id}
                            onClick={() => this.procedureSelection(proc.id)}
                            active={active}
            >
              <Table.Cell>{proc.code}</Table.Cell>
              <Table.Cell>{proc.description}</Table.Cell>
            </StyledTableRow>
        );

        usedProcedures.push(usedProcedureDescription);
      }
    });

    const disabledLeft = markedProcedures.length === 0 ||
        availableProcedures.some(proc => markedProcedures.includes(proc));
    const disabledRight = markedProcedures.length === 0 ||
        selectedAddProcedures.some(proc => markedProcedures.includes(proc));

    return (
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                <Grid.Row>
                  <StyledTableLeft>
                    {this.renderLeftTableSegment(getMessage("available"), selectableProcedures)}
                  </StyledTableLeft>
                  <StyledButtons textAlign='center' verticalAlign='middle'>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllProcedures(availableProcedures)}
                                  name='clipboard list'
                      />
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllProcedures(selectedAddProcedures)}
                                  name='clipboard list'
                      />
                    </StyledBtnContainer>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllProcedures([])}
                                  name='clipboard outline'
                      />
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllProcedures([])}
                                  name='clipboard outline'
                      />
                    </StyledBtnContainer>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  disabled={disabledRight}
                                  onClick={this.addRemoveProcedure}
                                  name='angle double right'
                      />
                      <StyledIcon bordered
                                  disabled={disabledLeft}
                                  onClick={this.addRemoveProcedure}
                                  name='angle double left'
                      />
                    </StyledBtnContainer>
                  </StyledButtons>
                  <StyledTableRight>
                    {this.renderRightTableSegment(getMessage("selected"), usedProcedures)}
                  </StyledTableRight>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    );
  }

  renderRightTableSegment = (headerText: string, usedProcedures: Array<React.ReactNode>): React.ReactNode => {
    const {getMessage} = this.props;

    return (
        <React.Fragment>
          <Header as='h5'>
            {headerText}:
          </Header>
          <ScrollableTableWrapper>
            <Table celled selectable size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{getMessage("id")}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage("description")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {usedProcedures}
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </React.Fragment>
    )
  };

  renderLeftTableSegment = (headerText: string, usedProcedures: Array<React.ReactNode>): React.ReactNode => {
    const {getMessage} = this.props;

    return (
        <React.Fragment>
          <Header as='h5'>
            {headerText}:
          </Header>
          <ScrollableTableWrapper>
            <Table celled selectable size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{getMessage("id")}</Table.HeaderCell>
                  <Table.HeaderCell>{getMessage("description")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {usedProcedures}
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </React.Fragment>
    )
  };

}

export default withMessages(ProcedureGroupSegment);
